enum SortTimelineBy {
  START_TIME = 'START_TIME',
  ALPHABETICAL = 'ALPHABETICAL',
}

export default SortTimelineBy;
